// Normalizes a raw transaction record (from the transaction list / lookup
// endpoint) into the shape CreateDisputeDialog's form and payload expect.
// Used by both entry points — the transaction-page nav handoff and the
// dispute-page search-and-pick flow — so there is exactly one place that
// knows which raw fields map to what. Note: the transaction object has no
// merchantName, only merchantId — the form shows merchantId accordingly.
export const mapTransactionToDisputeContext = (tx) => {
    if (!tx) return null;
    return {
      customerId: tx.customerId,
      merchantId: tx.merchantId,
      customerName: tx.customerName,
      customerEmail: tx.customerEmail,
      transactionAmount: tx.amount,
      transactionDate: tx.tranDate,
      transactionReference: tx.refNo,
      status: tx.status,
    };
  };